import React from 'react';
import { Box, useStyleConfig } from '@chakra-ui/react';

const Card = ({ variant = 'outline', children, ...props }) => {
  const styles = useStyleConfig('Card', { variant });
  return (
    <Box __css={styles.container} {...props}>
      {children}
    </Box>
  );
};

const CardHeader = ({ children, ...props }) => {
  const styles = useStyleConfig('Card');
  return (
    <Box __css={styles.header} {...props}>
      {children}
    </Box>
  );
};

const CardBody = ({ children, ...props }) => {
  const styles = useStyleConfig('Card');
  return (
    <Box __css={styles.body} {...props}>
      {children}
    </Box>
  );
};

const CardFooter = ({ children, ...props }) => {
  const styles = useStyleConfig('Card');
  return (
    <Box __css={styles.footer} {...props}>
      {children}
    </Box>
  );
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;










